import { render, staticRenderFns } from "./appLogin.vue?vue&type=template&id=57b507a0&scoped=true&"
import script from "./appLogin.vue?vue&type=script&lang=js&"
export * from "./appLogin.vue?vue&type=script&lang=js&"
import style0 from "./appLogin.vue?vue&type=style&index=0&id=57b507a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b507a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b507a0')) {
      api.createRecord('57b507a0', component.options)
    } else {
      api.reload('57b507a0', component.options)
    }
    module.hot.accept("./appLogin.vue?vue&type=template&id=57b507a0&scoped=true&", function () {
      api.rerender('57b507a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/h5/appLogin.vue"
export default component.exports